import { push } from "connected-react-router"
import { ListPanel } from "dash-styled"
import React, { FC, useCallback } from "react"
import { useDispatch } from "react-redux"
import { routePaths } from "../../../../../../Routes"

interface WorkerSubMenuProps {
    activeMenu: "worker" | "group"
    className?: string
    orgUsername: string
}

const items: { value: "worker" | "group"; label: string }[] = [
    { value: "worker", label: "Workers" },
    { value: "group", label: "Worker Groups" }
]

export const WorkerSubMenu: FC<WorkerSubMenuProps> = ({
    activeMenu,
    className,
    orgUsername
}) => {
    const dispatch = useDispatch()
    const handleClickSubMenuItem = useCallback(
        (clicked: "worker" | "group") =>
            dispatch(
                push(
                    clicked === "worker"
                        ? routePaths.orgWorkerList(orgUsername)
                        : routePaths.orgWorkerGroupList(orgUsername)
                )
            ),
        [dispatch, orgUsername]
    )

    return (
        <ListPanel
            className={`${className} w-40`}
            items={items}
            value={activeMenu}
            disableShadow={true}
            onClickItem={handleClickSubMenuItem}
        />
    )
}
